import { Component, OnInit } from '@angular/core';
import { PanelAdministracionService } from '../../../../panel-vigilancia/services/panel-administracion.service';
import { PanelCiudadano } from '../../../../../_entities/panelCiudadano/panelCiudadano';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { MapaService } from '../../../services/mapa.service';
import { HistoricoPanelComponent } from '../../popups/paneles/historico-panel/historico-panel.component';

@Component({
  selector: 'kt-ultima-transmision-boton-ciudadano',
  templateUrl: './ultima-transmision-boton-ciudadano.component.html',
  styleUrls: ['./ultima-transmision-boton-ciudadano.component.scss']
})
export class UltimaTransmisionBotonCiudadanoComponent implements OnInit {
  public paneles: PanelCiudadano[];
	public applyFilterTypes: any;
	public currentFilter: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	 isDiabled: boolean = true;
	public datosReporte = [];
  constructor(private mapaService:MapaService,private panelService:PanelAdministracionService,public dialogRef: MatDialogRef<UltimaTransmisionBotonCiudadanoComponent>,
		public dialog: MatDialog) { 
    this.showFilterRow = true;
		this.showHeaderFilter = true;
}

  ngOnInit(): void {
    this.obtenerPaneles();
  }

  obtenerPaneles(){
    this.panelService.obtenerUltimaPaneles().subscribe((result:PanelCiudadano[])=>{
      this.paneles = result;
      result.map(p => {
        if(p.boton == null || p.boton == ""){
          p.boton = 'Sin registro'
        } else{
          p.boton = p.boton
        }
      })
      result.map(q => {
        if(q.codigoProtocolo == null){
          q.codigoProtocolo = 'Sin registro'
        } else {
          q.codigoProtocolo = q.codigoProtocolo
        }
      })

      this.paneles.forEach(panel => {
        this.datosReporte.push({
          'Evento': this.obtenerEvento(panel.descripcionAlarma),
          'Nombre':panel.nombre,
          'Nombre del Botón': panel.boton,
          'Código': panel.codigoProtocolo,
          'Modelo':panel.modelo,
          'Número Seríe':panel.numeroSerie,
          'Descripción':panel.descripcion,
        });
      });
      if(this.datosReporte.length > 0) {
        this.isDiabled = false;
      }
    })
  }

  obtenerEvento(descripcionAlarma) {  
		let evento = '';
		switch (descripcionAlarma) {
			case 'Lid Restored':
				evento = 'Tapa Restaurada';
				break;
			case 'Lid Opened':
				evento = 'Tapa Abierta';
				break;
      case 'Audible Panic Alarm':
        evento = 'Alarma de Pánico';
        break;
      case 'Alarm Silenced':
        evento = 'Alarma Silenciada';
        break;
      case 'Device Restored':
        evento = 'Dispositivo Restaurado';
        break;
      case 'IP Address Already Used':
        evento = 'Dirección IP Utilizada';
        break;
      case 'Normal IP address':
        evento = 'DIrección IP Normal';
        break;
      case 'Armed':
        evento = 'Armado';
        break;
      case 'Disarmed':
        evento = 'Desarmado';
        break;

      case 'Expander AC Power Loss':
				evento = 'Perdida de Alimentación';
				break;
      case '24H Alarm':
        evento = 'Alarma Sensor de Movimiento'
        break;
      case 'Network Fault':
        evento = 'Fallo de Red';
        break;
      case 'Device Offline':
        evento = 'Dispositivo Sin Conexión';
        break;

      case 'Cellular Fault':
        evento = 'Fallo de Celular';
        break;
      case 'Cellular Restored':
        evento = 'Celular Restaurado';
        break;
      case 'Mains Power Lost':
        evento = 'Perdida de Alimentación de Red'
        break;
      case 'Jamming Detected':
        evento = 'Interferencia Detectada';
        break;
      case 'Jamming Restored':
        evento = 'Interferencia Restaurada';
        break;
      case 'Device Enrolled':
        evento = 'Dispositivo Inscrito';
        break;
      case 'Device Deleted':
        evento = 'Dispositivo Eliminado'
        break;

      case 'Mains Power Restored':
        evento = 'Red Eléctrica Restaurada';
        break;
      case 'Network Restored':
        evento = 'Red Restaurada';
        break;

      case null:
        evento = 'Sin Datos';
        break;
		}
		return evento;
	}

  public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

	ubicarPuntoHistorico(data) {
		this.mapaService.ocultarUbicadorPanelesLayer();
		this.dialogRef.close();
		this.mapaService.verPanel(data);
	}

  historicoPanel(data){
    const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.width = "58%";
		dialogConfig.data = data;
		this.dialogRef.close();
		this.dialog.open(HistoricoPanelComponent, dialogConfig);
  }

}
